import React from "react";
import LanguageLink from "../routing/LanguageLink"; // Ensuring LanguageLink is used if applicable, or generic Link/a
import SEOHead from "../section/SeoHead";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const Disclaimer = () => {
  const { t } = useTranslation();

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Disclaimer - Citizen Hub",
    description: "Legal disclaimer for Citizen Hub Immigration Services.",
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <SEOHead
        title={`${t("legal.disclaimer.title")} - Citizen Hub`}
        description={t("legal.disclaimer.intro")}
        canonicalUrl="https://citiznhub.com/disclaimer"
        structuredData={structuredData}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 border-b pb-4">
            {t("legal.disclaimer.title")}
          </h1>

          <div className="prose prose-blue max-w-none text-gray-700 space-y-6">
            <p className="lead text-lg text-gray-600 italic">
              {t("legal.disclaimer.intro")}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                {t("legal.disclaimer.important_notice_title")}
              </h2>
              <p>{t("legal.disclaimer.important_notice_text")}</p>
            </section>

            <section className="bg-blue-50 p-6 rounded-xl border border-blue-100">
              <h2 className="text-2xl font-semibold text-blue-900 mb-4 flex items-center gap-2">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                {t("legal.disclaimer.not_legal_advice_title")}
              </h2>
              <p className="text-blue-800 font-medium">
                {t("legal.disclaimer.not_legal_advice_text")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                {t("legal.disclaimer.immigration_services_title")}
              </h2>
              <p>{t("legal.disclaimer.no_guarantees_title")}: {t("legal.disclaimer.final_notice_text")}</p>
              {/* Reusing keys to construct paragraph roughly, or just mapping simple sections */}
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                {t("legal.disclaimer.limitation_liability_title")}
              </h2>
              <p>{t("legal.disclaimer.final_notice_text")}</p>
            </section>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t("legal.disclaimer.final_notice_title")}
              </h3>
              <p className="text-gray-600">
                {t("legal.disclaimer.final_notice_text")}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Disclaimer;
